<div class="ui-g-12 store-filter-section">
  <div class="topbar-search">
    <input #groupSearch data-testid="groupSearch" type="text" placeholder="{{ 'campaign.searchSavedGroup' | translate }}" (keyup)="0"/>
    <div class="topbar-search-icon fa fa-search"></div>
  </div>
</div>

<div class="ui-dialog-inner">
  <div class="ui-g-12">
    <div class="saved">{{ groups.length }} {{ 'campaign.savedGroups' | translate }}</div>
  </div>

  <div class="ui-g-12">
    <hr style="border-top:0px; border-color:#dde3e6">
  </div>

  <div class="ui-g-4"></div>
  <div class="ui-g-4 text-right">
    <button
      pButton
      type="button"
      class="add-selected-stores-btn"
      label="{{ 'common.add' | translate }}"
      (click)="addStoresFromGroups()">
    </button>
  </div>

  <div class="ui-g-12">
    <p-dataTable [value]="groups" [globalFilter]="groupSearch" class="store-table">
      <p-column styleClass="col-button">
        <ng-template let-col let-group="rowData" pTemplate="body">
          <p-radioButton name="selectedGroupsId" value={{group.id}} [(ngModel)]="selectedGroupsId"></p-radioButton>
        </ng-template>
      </p-column>
      <p-column field="id" hidden="true"></p-column>
      <p-column field="name" header="{{ 'common.storeGroupName' | translate }}"></p-column>
      <p-column field="stores_host_code" header="{{ 'campaign.storeCodes' | translate }}"></p-column>
    </p-dataTable>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-add-store-group/campaign-add-store-group.component.html